/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_AddInputs */

const vi_lot_items_add = /** @type {(inputs: Lot_Items_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm lô`)
};

/**

* @param {Lot_Items_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_add = /** @type {((inputs?: Lot_Items_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_add(inputs)
});